module.exports = __webpack_public_path__ + "img/self-learning.c30e62ba.png";